export const getCountryCode = (countryLocale) => {
  const countryCodes = new Map([
    ['br', '55'],
    ['th', '66'],
    // add more country locale and their codes here
    // e.g., ['us', '1'], ['de', '49']
  ]);
  const defaultCode = '66';
  return countryCodes.get(countryLocale || defaultCode);
};
